// extracted by mini-css-extract-plugin
export default {"container":"style_container__+UJ1+","block":"style_block__Ich5H","header":"style_header__bxw6A","text":"style_text__qVN53","button":"style_button__bkGCx"};